import React, { useEffect, useState } from 'react';
import { MetaTags } from 'react-meta-tags';
//import Breadcrumbs
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';
import { useHistory } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import RefundOrderAmountList from '../components/BankRefundList';

import {
  getRefundDetail,
  updateRefund,
} from '../../../Redux/refund/refundSlice';
import {
  fetchRefundAmountDetail,
  fetchUpdateBankRefundDetails,
} from '../action/action';
import toast, { Toaster } from 'react-hot-toast';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import {
  Col,
  Container,
  Row,
  FormGroup,
  CardBody,
  CardHeader,
  Modal,
  CardTitle,
  Spinner,
} from 'reactstrap';
import BankRefundList from '../components/BankRefundList';
import ManageBankRefundExport from './components/ManageBankRefundExport';
import { CUSTOMER_CARE_SUPERVISOR_ROLE_ID, STORE_CUSTOMER_CARE_SUPERVISOR_ROLE_ID } from '../../../constants/roles';
const BankRefunds = () => {
  const [position, setPosition] = useState();
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [isPartialRefund, setPartialRefund] = useState(true);
  const [isFullRefund, setFullRefund] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefundError, setisRefundError] = useState('');
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [modal_password, setmodal_password] = useState(false);
  const [updateStsLoad, setUpdateDetailsLoad] = useState(false);
  const [isUpdateRefund, setUpdateRefund] = useState(true);
  const [inputValue, setInputValue] = useState('');
  const [refNo, setRefNumber] = useState('');
  const [refReason, setRefReason] = useState('');
  const [refAmount, setRefAmount] = useState('');
  const [refRemarks, setRefRemarks] = useState('');
  const [apiPassword, setApipassword] = useState('');
  const [paymentMode, setPaymentMode] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [storeName, setStoreName] = useState('');
  const history = useHistory();
  const [refundType, setRefundType] = useState('full'); // Changed default to 'full'
  const [isSubmitting, setIsSubmitting] = useState(false); // Add state for loader
  const [stores, setStores] = useState();
  const [isButtonLoading, setIsButtonLoading] = useState(false); // Add state for button loader
  const [primaryReason, setPrimaryReason] = useState(''); // State for primary reason
  const [secondaryReason, setSecondaryReason] = useState(''); // State for secondary reason
  const [tertiaryReason, setTertiaryReason] = useState(''); // State for tertiary reason
  let userID = '';
  let UserRoleID = '';
  let created_by = '';
  let created_by_username = '';
  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser')); console.log(userObj, 'userObj');
    if (userObj?.role_id !== undefined) {
      userID = userObj?.user_id;
      UserRoleID = userObj?.role_id;
      created_by = userObj?.user_id;
      created_by_username = userObj?.user_name;
    }
  }
  const handleChangeRefund = (e, types) => {
    if (types === 'full' && e.target.value === 'fully_refunded') {
      setFullRefund(true);
      setPartialRefund(false);
      setIsDisabled(true);
      setRefundType(e.target.value);
      setRefAmount(RefundData?.refundeligibleamount); // Set default value for full refund
    } else {
      setPartialRefund(true);
      setFullRefund(false);
      setIsDisabled(false);
      setRefundType(e.target.value);
      setRefAmount(''); // Clear the field for partial refund
    }
  };
  const dispatch = useDispatch();
  const toggleRightDrawer = () => {
    setPosition('right');
    setOpen(!open);
  };
  const onDrawerClose = () => {
    setInputValue('');
    setOpen(false);
  };
  const resetInputField = () => {
    dispatch(getRefundDetail(null));
    setInputValue('');
  };

  const handleUserInput = (e) => {
    dispatch(getRefundDetail(null));
    setInputValue(e.target.value);
  };

  function removeBodyCss() {
    document.body.classList.add('no_padding');
  }

  const { refundDetail = [], isRefundLoading } = useSelector(
    (state) => state.refund
  );

  const handleRefundSubmit = async (events, values) => {
    setIsSubmitting(true); // Show loader
    const reference_no = values?.reference_no ? values?.reference_no : '';

    setmodal_backdrop(false);
    await fetchRefundAmountDetail({
      params:
      {
        ls_reference: reference_no,
        stores
      },
      dispatch,
    });
    setIsSubmitting(false); // Hide loader
  };

  const { updateRefundDetail = [], isupdaterfeundLoading } = useSelector(
    (state) => state.refund
  );
  const handleRefundUpdate = (events, values) => {
    const referenceno = values?.reference_no ? values?.reference_no : '';
    const storeName = values?.store_name ? values?.store_name : '';
    const storeId =
      storeName === 'BARSHA'
        ? 1
        : storeName === 'SHARJAH'
          ? 2
          : storeName === 'Online'
            ? 3
            : null;

    console.log('values', values);
    console.log('store_id', storeId);

    const date = values?.date ? values?.date : '';
    const refundamount = values?.refundamount ? values?.refundamount : '';
    const balanceamount = values?.balanceamount ? values?.balanceamount : '';
    const paymentMode = values?.payment_mode ? values?.payment_mode : '';
    const refundreason = values?.rc ? values?.rc : '';
    const remarks = values?.Remarks ? values?.Remarks : '';
    const newrefundamount = values?.newrefundamount
      ? values?.newrefundamount
      : '';
    const password = values?.password ? values?.password : '';
    const refund_type = values?.refund_type ? values?.refund_type : '';

    if (newrefundamount > balanceamount) {
      setisRefundError(refundamount);
    } else {
      setisRefundError('');
      if (isUpdateRefund) {
        tog_backdrop();
      }
      setRefNumber(referenceno);
      setRefReason(refundreason);
      setRefAmount(newrefundamount);
      setRefRemarks(remarks);
      setPaymentMode(paymentMode);
      setApipassword(password);
      setRefundType(refundType);
    }
  };

  function tog_backdrop() {
    onDrawerClose();
    setmodal_backdrop(!modal_backdrop);
    removeBodyCss();
  }
  function tog_password() {
    setmodal_backdrop(false);
    onDrawerClose();
    setmodal_password(!modal_password);
    removeBodyCss();
  }
  const RefundData = refundDetail?.OrderDetails?.[0];
  let BalanceAmount = RefundData?.Amount - RefundData?.RefundAmount;

  const handleRefundUpdateSubmit = (
    reference_no,
    amount,
    full_name,
    store_name
  ) => {
    setLoading(true);

    const email = RefundData?.email ? RefundData.email : null; // Check if email exists
    const phone = RefundData?.phone ? RefundData.phone : null; // Check if phone exists
    let country = RefundData?.country ? RefundData.country : null; // Check if country exists
    const store_code = RefundData?.store_code ? RefundData.store_code : null; // Check if store_code exists
    let currency = RefundData?.currency ? RefundData.currency : null;
    // If country is null, determine from store_code
    if (!country && store_code) {
      country = getCountryByStore(store_code);
    }

    const primaryLabel = reasons.primary.find(
      (reason) => reason.value === primaryReason
    )?.label;

    const secondaryLabel = reasons.secondary[primaryReason]?.find(
      (reason) => reason.value === secondaryReason
    )?.label;

    const tertiaryLabel = reasons.tertiary[secondaryReason]?.find(
      (reason) => reason.value === tertiaryReason
    )?.label;

    fetchUpdateBankRefundDetails({
      params: {
        reference_no: reference_no,
        amount: refAmount,
        full_name: full_name,
        store_name: store_code, // Pass store_name directly
        email: email, // Pass email if it exists
        phone: phone, // Pass phone if it exists
        country: country, // Use determined country
        currency: currency ? currency : '',
        refund_reason: primaryLabel, // Send label instead of value
        refund_reason_primary: secondaryLabel, // Send label instead of value
        refund_reason_specific: tertiaryLabel, // Send label instead of value
        remarks: refRemarks,
        created_by: created_by, // Append created_by parameter
        created_by_username: created_by_username, // Append created_by_username parameter
      },
      dispatch,
    });
  };

  useEffect(() => {
    if (updateRefundDetail?.code === 100) {
      setLoading(false);
      setUpdateDetailsLoad(false);
      setCount(0);
      dispatch(getRefundDetail(null));
      tog_backdrop();

      toast.success('Successfully submited', {
        style: {
          border: '1px solid #fff',
          padding: '20px',
          color: '#ffffff',
          background: '#4CAF50',
        },
        iconTheme: {
          primary: '#FFFAEE',
          secondary: '#4CAF50',
        },
      });
      dispatch(updateRefund(null));
      setTimeout(() => {
        history.push('/Refunds/banklist');
      }, 10);
    } else {
      if (updateRefundDetail?.message) {
        /* if (updateRefundDetail?.message === 'Invalid password') {
          toggleRightDrawer();
        }
          */
        setmodal_backdrop(false);
        setCount(0);

        setLoading(false);

        toast.error(updateRefundDetail?.message, {
          style: {
            border: '1px solid #fff',
            padding: '20px',
            color: '#ffffff',
            background: '#f44336',
          },
          iconTheme: {
            primary: '#FFFAEE',
            secondary: '#f44336',
          },
        });
        dispatch(updateRefund(null));
      } else {
      }
    }
  }, [updateRefundDetail]);
  useEffect(() => {
    const stored = localStorage.getItem('authUser');
    if (stored) {
      const userObj = JSON.parse(stored);
      try {
        if (userObj?.stores) {
          setStores(userObj?.stores);
        }
      } catch (err) {
        console.error('Invalid salesPersonCode', err);
      }
    }
  }, []);

  let refundValue = '';
  if (RefundData?.RefundAmount === 0) {
    refundValue = RefundData?.refundeligibleamount;
  } else {
    refundValue = RefundData?.Amount - RefundData?.refundeligibleamount;
  }

  const reasons = {
    primary: [
      { value: "customer", label: "Customer" },
      { value: "product", label: "Product" },
      { value: "sale_assistance", label: "Sale Assistance" },
      { value: "delivery", label: "Delivery" },
      { value: "escalation", label: "Escalation" },
    ],
    secondary: {
      customer: [
        { value: "no_longer_needed", label: "No longer needed" },
        { value: "found_better_option", label: "Found a better option" },
        { value: "bought_by_mistake", label: "Bought by mistake" },
        { value: "impulse_purchase", label: "Impulse purchase" },
        { value: "price_dropped", label: "Price dropped after purchase" },
        { value: "found_cheaper_alternative", label: "Found cheaper alternative" },
        { value: "not_worth_price", label: "Not worth the price" },
        { value: "contractor_customer_mismatch", label: "Contractor & customer not aligned with the item" },
        { value: "excess_material_return", label: "Excess material return" },
        { value: "style_not_matching", label: "Style doesn’t match customer’s taste (too modern or too classic)" },
        { value: "site_not_ready", label: "Customer site not ready" },
        { value: "not_matching_interior", label: "Not matching the home interior design & display" },
      ],
      product: [
        { value: "defective_damaged", label: "Defective or Damaged" },
        { value: "poor_quality", label: "Poor Quality" },
        { value: "not_as_described", label: "Product not as Described" },
        { value: "sizing_fit_issues", label: "Sizing or Fit issues" },
      ],
      delivery: [
        { value: "shipping_issues", label: "Shipping & Fulfillment Issues" },
        { value: "installation_issues", label: "Installation issues" },
        { value: "delivery_crew", label: "Delivery crew" },
      ],
      sale_assistance: [
        { value: "wrong_information", label: "Wrong information/ Over commitment from the staff" },
        { value: "wrong_order", label: "Wrong order/item punched" },
        { value: "incorrect_promotion", label: "Incorrect Promotion & discounts applied" },
        { value: "staff_attitude", label: "Staff attitude & customer handling" },
      ],
      escalation: [
        { value: "no_questions_asked", label: "Customer Delight – no questions asked return" },
        { value: "escalated_to_management", label: "Customer escalated to higher management" },
        { value: "higher_management_reference", label: "Reference/Direction from higher management" },
      ],
    },
    tertiary: {
      not_matching_interior: [
        { value: "style_color_texture", label: "Style/color/Texture /pattern did not complement existing décor" },
      ],
      defective_damaged: [
        { value: "item_arrived_broken", label: "Item arrived broken (damaged or broken parts)" },
        { value: "doesnt_work_properly", label: "Doesn't work properly" },
        { value: "chip_offs", label: "Chip offs and peeling" },
        { value: "fading_sagging", label: "Fading and product sagging" },
        { value: "smell_issue", label: "Smell issue" },
        { value: "missing_parts", label: "Missing parts or accessories" },
        { value: "poor_packaging", label: "Packaging was poor/damaged" },
      ],
      poor_quality: [
        { value: "not_durable", label: "Not durable" },
        { value: "cheap_materials", label: "Materials feel cheap" },
        { value: "manufacturing_issue", label: "Manufacturing/Supplier Issue" },
      ],
      not_as_described: [
        { value: "looks_different", label: "Product looks different from what was shown in the store or online" },
        { value: "incorrect_size_color", label: "Incorrect size/color" },
        { value: "light_issue", label: "Light is too dim or too bright" },
        { value: "wrong_specifications", label: "Wrong specifications" },
      ],
      sizing_fit_issues: [
        { value: "doesnt_fit", label: "Doesn’t fit my space/need" },
        { value: "sizing_mismatch", label: "Sizing doesn’t match description" },
        { value: "too_large", label: "Product too large" },
        { value: "too_small", label: "Product too small" },
      ],
      shipping_issues: [
        { value: "wrong_item_sent", label: "Wrong item sent/delivered" },
        { value: "delayed_delivery", label: "Delayed delivery" },
        { value: "incomplete_order", label: "Incomplete/partial order delivered" },
        { value: "transit_damage", label: "Transit damage" },
      ],
      installation_issues: [
        { value: "installation_delay", label: "Installation delay" },
        { value: "not_going_through", label: "Not going through lift or stairway" },
        { value: "unable_to_fix", label: "Installation team unable to fix due to weight or ceiling type" },
        { value: "heavy_ceiling_issue", label: "Heavy or not suitable for ceiling type" },
        { value: "incomplete_installation", label: "Incomplete/wrong installation" },
      ],
      delivery_crew: [
        { value: "crew_attitude", label: "Delivery crew attitude & customer handling" },
        { value: "rude_tone", label: "Rude and inappropriate tone used" },
        { value: "hygiene_appearance", label: "Personal hygiene and appearance" },
      ],
    },
  };

  useEffect(() => {
    if (secondaryReason && !reasons.tertiary[secondaryReason]) {
      setTertiaryReason(""); // Clear tertiary reason if no related options
    }
  }, [secondaryReason]);

  const shouldShowTertiaryDropdown = secondaryReason && reasons.tertiary[secondaryReason];

  useEffect(() => {
    if (RefundData?.refundeligibleamount) {
      setRefAmount(RefundData.refundeligibleamount);
    }
  }, [RefundData]);

  useEffect(() => {
    if (primaryReason) {
      const selectedPrimary = reasons.primary.find(
        (reason) => reason.value === primaryReason
      );
      setPrimaryReason(selectedPrimary?.value || "");
    }
  }, [primaryReason]);

  useEffect(() => {
    if (secondaryReason) {
      const selectedSecondary = reasons.secondary[primaryReason]?.find(
        (reason) => reason.value === secondaryReason
      );
      setSecondaryReason(selectedSecondary?.value || "");
    }
  }, [secondaryReason, primaryReason]);

  useEffect(() => {
    if (tertiaryReason) {
      const selectedTertiary = reasons.tertiary[secondaryReason]?.find(
        (reason) => reason.value === tertiaryReason
      );
      setTertiaryReason(selectedTertiary?.value || "");
    }
  }, [tertiaryReason, secondaryReason]);

  // Helper to get country code from store code
  function getCountryByStore(storeCode) {
    if ([
      'BARSHA', 'DHECOMM', 'DIBBA', 'FUJ', 'ICT', 'JIMIM', 'RAK_B2C', 'REEMM', 'SHJHOME'
    ].includes(storeCode)) return 'ae';
    if ([
      'DANDIROM', 'SOHR', 'SUR', 'BARKA', 'NIZWA', 'ALKWH', 'MBLB2C', 'ALKHWR'
    ].includes(storeCode)) return 'om';
    if ([
      'DANDIRBH', 'SLMBD'
    ].includes(storeCode)) return 'bh';
    if ([
      'DANDIRQR', 'SALWA'
    ].includes(storeCode)) return 'qa';
    return '';
  }

  return (
    <React.Fragment>
      {loading ? (
        <div className="loader-container">
          <Spinner type="grow" className="ms-2" color="dark" />
        </div>
      ) : (
        <></>
      )}
      <div className="page-content refundOrder">
        <MetaTags>
          <title>Bank Transfer Request</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col>
              <DashBreadcrumb
                title="Orders"
                breadcrumbItem="Bank Transfer Request"
              />
            </Col>
            {UserRoleID === '1' || UserRoleID === CUSTOMER_CARE_SUPERVISOR_ROLE_ID || UserRoleID === STORE_CUSTOMER_CARE_SUPERVISOR_ROLE_ID ? (
              <>
                <Col md={2} className="textAlignRight mb-4">
                  <button
                    type="submit"
                    className="btn btn-dark"
                    onClick={toggleRightDrawer}
                  >
                    Add Bank Transfer
                  </button>
                </Col>
              </>
            ) : (
              <></>
            )}
            <Col style={{ width: 'auto' }}>
              <ManageBankRefundExport />
            </Col>
          </Row>
          <ReactDrawer
            open={open}
            position={position}
            onClose={onDrawerClose}
            className="sideNavWidth"
          >
            <Card
              className="card-h-100 OrderDetailsBox"
              style={{ overflowY: 'scroll' }}
            >
              <CardHeader>
                <Row>
                  <Col>
                    <CardTitle>Bank Transfer Request </CardTitle>
                  </Col>
                  <Col className="textAlignRight">
                    {' '}
                    <button
                      type="button"
                      className="btn-close "
                      onClick={() => {
                        tog_backdrop();
                        resetInputField();
                      }}
                      aria-label="Close"
                    ></button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="searchBox">
                  <AvForm
                    id="refundForm"
                    className="needs-validation"
                    onValidSubmit={(e, v) => {
                      handleRefundSubmit(e, v);
                    }}
                  >
                    <div className="d-inline-block float-md-start me-1 mb-1 search-input-container w-100 mb-3">
                      <AvField
                        name="reference_no"
                        label="Reference No"
                        value={inputValue}
                        onChange={(e) => handleUserInput(e)}
                        className="form-control"
                        placeholder=""
                        type="text"
                      />
                      <button
                        className="btn btn-dark "
                        type="submit"
                        style={{ position: 'absolute', top: 24, right: 0 }}
                        disabled={isSubmitting} // Disable button while submitting
                      >
                        {isSubmitting ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <i className="bx bx-search-alt align-middle "></i>
                        )}
                      </button>
                    </div>
                  </AvForm>
                </div>
                {RefundData !== undefined ? (
                  <>
                    {RefundData?.PaymentMode !== 'cashondelivery1' ? (
                      <>
                        {' '}
                        <AvForm
                          className="needs-validation"
                          onValidSubmit={(e, v) => {
                            // handlePasswordSubmit(e, v);
                            handleRefundUpdate(e, v);
                          }}
                        >
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <AvField
                                  name="full_name"
                                  label="Customer Name"
                                  value={RefundData?.full_name}
                                  className="form-control"
                                  placeholder=""
                                  type="text"
                                  required
                                  disabled
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <h6 className="mb-3 text-muted">
                                Reference Number
                              </h6>
                              <p>{RefundData?.ls_reference}</p>
                            </Col>
                            <Col md="6">
                              <h6 className="mb-3 text-muted">Store Code</h6>
                              <p>{RefundData?.store_code}</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <h6 className="mb-3 text-muted">
                                Order Created Date
                              </h6>
                              <p>{RefundData?.created_date || 'No available'}</p>
                            </Col>
                            <Col md="6">
                              <h6 className="mb-3 text-muted">Payment Mode</h6>
                              <p>{RefundData?.payment_mode}</p>
                            </Col>
                          </Row>

                          <Row>
                            <Col md="12" className="mb-3">
                              <FormGroup>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="refundType"
                                    id="fullRefund"
                                    value="full"
                                    checked={refundType === 'full'}
                                    onChange={(e) => {
                                      setRefundType(e.target.value);
                                      setIsDisabled(true);
                                      setRefAmount(RefundData?.refundeligibleamount);
                                    }}
                                  />
                                  <label className="form-check-label" htmlFor="fullRefund">
                                    Full Refund
                                  </label>
                                </div>
                                {RefundData?.refundeligibleamount > 0 && ( // Only show Partial Refund if refundeligibleamount > 0
                                  <div className="form-check form-check-inline">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="refundType"
                                      id="partialRefund"
                                      value="partial"
                                      checked={refundType === 'partial'}
                                      onChange={(e) => {
                                        setRefundType(e.target.value);
                                        setIsDisabled(false);
                                        setRefAmount('');
                                      }}
                                    />
                                    <label className="form-check-label" htmlFor="partialRefund">
                                      Partial Refund
                                    </label>
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <h6 className="mb-3 text-muted">Order Amount</h6>
                              <p style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                                {new Intl.NumberFormat('en-US', {
                                  style: 'currency',
                                  currency: RefundData?.currency,
                                }).format(RefundData?.amount)}
                              </p>
                            </Col>
                            <Col md="6">
                              <FormGroup className="mb-3">
                                <AvField
                                  name="refundamount"
                                  label="Amount to be Refunded"
                                  className="form-control"
                                  placeholder=""
                                  type="text"
                                  required
                                  disabled={refundType === 'full'}
                                  value={refundType === 'full' ? RefundData?.refundeligibleamount : refAmount} // Show value based on refund type
                                  validate={{
                                    required: { value: true, errorMessage: 'Refund amount is mandatory.' },
                                    pattern: {
                                      value: '^\\d+(\\.\\d{1,2})?$',
                                      errorMessage: 'Enter a valid amount.',
                                    },
                                    max: {
                                      value: RefundData?.refundeligibleamount,
                                      errorMessage: `Refund amount cannot exceed ${RefundData?.refundeligibleamount}.`,
                                    },
                                  }}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setRefAmount(value);
                                    if (!value) {
                                      setisRefundError('Refund amount cannot be empty.');
                                    } else if (parseFloat(value) > RefundData?.refundeligibleamount) {
                                      setisRefundError(`Refund amount cannot exceed ${RefundData?.refundeligibleamount}.`);
                                    } else {
                                      setisRefundError('');
                                    }
                                  }}
                                />
                                {isRefundError && <span className="text-danger">{isRefundError}</span>}
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <AvField
                                  type="select"
                                  name="primary_reason"
                                  label="Refund Reason"
                                  value={primaryReason}
                                  onChange={(e) => {
                                    setPrimaryReason(e.target.value);
                                    setSecondaryReason(''); // Reset secondary and tertiary when primary changes
                                    setTertiaryReason('');
                                  }}
                                  required
                                >
                                  <option value="">Select Refund Reason</option>
                                  {reasons.primary.map((reason) => (
                                    <option key={reason.value} value={reason.value}>
                                      {reason.label}
                                    </option>
                                  ))}
                                </AvField>
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            {primaryReason && (
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <AvField
                                    type="select"
                                    name="secondary_reason"
                                    label="Primary Cause"
                                    value={secondaryReason}
                                    onChange={(e) => {
                                      setSecondaryReason(e.target.value);
                                      setTertiaryReason(''); // Reset tertiary when secondary changes
                                    }}
                                    required
                                  >
                                    <option value="">Select </option>
                                    {reasons.secondary[primaryReason]?.map((reason) => (
                                      <option key={reason.value} value={reason.value}>
                                        {reason.label}
                                      </option>
                                    ))}
                                  </AvField>
                                </FormGroup>
                              </Col>
                            )}
                          </Row>
                          <Row>
                            {shouldShowTertiaryDropdown && (
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <AvField
                                    type="select"
                                    name="tertiary_reason"
                                    label="Specific Cause"
                                    value={tertiaryReason}
                                    onChange={(e) => setTertiaryReason(e.target.value)}
                                    required
                                  >
                                    <option value="">Select</option>
                                    {reasons.tertiary[secondaryReason]?.map((reason) => (
                                      <option key={reason.value} value={reason.value}>
                                        {reason.label}
                                      </option>
                                    ))}
                                  </AvField>
                                </FormGroup>
                              </Col>
                            )}
                          </Row>
                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <AvField
                                  name="Remarks"
                                  label="Remarks"
                                  value={refRemarks}
                                  className="form-control"
                                  placeholder=""
                                  type="textarea"
                                  style={{ height: '100px' }} // Increased height
                                  onChange={(e) =>
                                    setRefRemarks(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>

                            <Col md="6"></Col>

                            <Col
                              md="12"
                              className="d-flex justify-content-start"
                            >
                              {' '}
                              {/* Align buttons in the same row with custom padding */}
                              <button
                                type="button"
                                className="btn btn-success" // Small button with green background
                                onClick={() => {
                                  if (!refAmount || !primaryReason) {
                                    toast.error('Refund amount and reason are mandatory.', {
                                      style: {
                                        border: '1px solid #fff',
                                        padding: '20px',
                                        color: '#ffffff',
                                        background: '#f44336',
                                      },
                                      iconTheme: {
                                        primary: '#FFFAEE',
                                        secondary: '#f44336',
                                      },
                                    });
                                    return;
                                  }

                                  setIsButtonLoading(true); // Show loader
                                  handleRefundUpdateSubmit(
                                    RefundData?.ls_reference,
                                    RefundData?.refunsEligibleamount,
                                    RefundData?.full_name,
                                    storeName // Use state value instead of querying DOM
                                  );
                                }}
                              >
                                {isButtonLoading && (
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                )}{' '}
                                Submit
                              </button>
                              <button
                                type="button"
                                className="btn btn-danger ms-2" // Small button with red background
                                onClick={() => {
                                  setmodal_backdrop(false);
                                  dispatch(getRefundDetail(null));
                                }}
                              >
                                Cancel
                              </button>
                            </Col>
                          </Row>

                          <Modal
                            isOpen={modal_backdrop}
                            toggle={() => {
                              tog_backdrop();
                            }}
                            backdrop={'static'}
                            id="staticBackdrop"
                          >
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="staticBackdropLabel"
                              >
                                Refund Amount
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => {
                                  setmodal_backdrop(false);
                                }}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <p>Do you want to refund the Amount?</p>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-light"
                                onClick={() => {
                                  setmodal_backdrop(false);
                                  dispatch(getRefundDetail(null));
                                }}
                              >
                                Cancel
                              </button>
                              {count < 1 ? (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-dark"
                                    onClick={() => {
                                      handleRefundUpdateSubmit();
                                      setCount(count + 1);
                                      setmodal_backdrop(false);
                                      dispatch(getRefundDetail(null));
                                    }}
                                  >
                                    {updateStsLoad === true && (
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                    )}{' '}
                                    Submit
                                  </button>
                                </>
                              ) : null}
                            </div>
                          </Modal>
                        </AvForm>
                      </>
                    ) : (
                      <>
                        <div
                          className=""
                          style={{
                            margin: '85px 0px',
                            padding: '11px',
                            width: '100%',
                            color: '#000',
                            backgroundColor: '#f3d8d8',
                            textAlign: 'center',
                          }}
                        >
                          Refund Payment Just Allowed for COB Users Only.
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {refundDetail?.code === 101 ? (
                      <>
                        <div
                          className=""
                          style={{
                            margin: '85px 0px',
                            padding: '11px',
                            width: '100%',
                            color: '#000',
                            backgroundColor: '#f3d8d8',
                            textAlign: 'center',
                          }}
                        >
                          {refundDetail?.message}
                        </div>
                      </>
                    ) : null}
                  </>
                )}
              </CardBody>
            </Card>
          </ReactDrawer>
          <BankRefundList stores={stores} />
        </Container>
      </div>

      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default BankRefunds;
